import { createBrowserRouter } from "react-router";
import { LoginScreen } from "../features/auth/LoginScreen.js";
import {
  AiAgentScreen,
  AutomationsScreen,
  BroadcastsScreen,
  CampaignsScreen,
  ContactsScreen,
  DashboardScreen,
  InboxScreen,
  SettingsScreen,
  TemplatesScreen,
} from "./screens.js";
import { AppShell } from "./shell/AppShell.js";

// React Router v7 library mode (doc 14 ADR-05). Paths per doc 01's mapping.
export const router = createBrowserRouter([
  { path: "/login", element: <LoginScreen /> },
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <DashboardScreen /> },
      { path: "inbox", element: <InboxScreen /> },
      { path: "broadcasts", element: <BroadcastsScreen /> },
      { path: "campaigns", element: <CampaignsScreen /> },
      { path: "templates", element: <TemplatesScreen /> },
      { path: "contacts", element: <ContactsScreen /> },
      { path: "automations", element: <AutomationsScreen /> },
      { path: "ai-agent", element: <AiAgentScreen /> },
      { path: "settings", element: <SettingsScreen /> },
    ],
  },
]);
